import { createContext } from '@chakra-ui/react-utils'

const [FieldListProvider, useFieldListContext] = createContext({
  name: 'FieldListContext',
  errorMessage:
    'useFieldListContext: `context` is undefined. Seems you forgot to wrap the accordion components in `<FieldList />`'
})

export const useFieldList = ({ isLoading = false, isReadOnly = true }) => {
  const getFieldListItemProps = () => {
    return {
      isLoading,
      isReadOnly
    }
  }

  return {
    getFieldListItemProps
  }
}

export const useFieldListItem = props => {
  const { getFieldListItemProps } = useFieldListContext()
  const { isLoading, isReadOnly } = getFieldListItemProps()

  return {
    isLoading,
    isReadOnly
  }
}

export { FieldListProvider, useFieldListContext }
